// shop by car pop up
document.addEventListener('DOMContentLoaded', function () {
  // Get all triggers, popup, and close button
  const triggers = document.querySelectorAll('.cst-shop-by-car-flex-container');
  const popupOverlay = document.getElementById('popupOverlay');
  const closePopup = document.getElementById('closePopup');
  const body = document.body;
  const homepageCtaButton = document.getElementById('homepage-banner-cta'); 

  // Open the pop-up when any trigger is clicked
  triggers.forEach(function(trigger) {
    trigger.addEventListener('click', function() {
      popupOverlay.classList.add('cst-show');
      body.classList.add('no-scroll'); // Disable background scrolling
    });
  });

  // Open the pop-up when the new button is clicked
  if (homepageCtaButton) {
    homepageCtaButton.addEventListener('click', function() {
      popupOverlay.classList.add('cst-show');
      body.classList.add('no-scroll'); // Disable background scrolling
    });
  }

  // Close the pop-up when the close button is clicked
  closePopup.addEventListener('click', function() {
    popupOverlay.classList.remove('cst-show');
    body.classList.remove('no-scroll'); // Enable background scrolling
  });

  // Close the pop-up if the user clicks outside of the popup content area
  popupOverlay.addEventListener('click', function(e) {
    if (e.target === popupOverlay) {
      popupOverlay.classList.remove('cst-show');
      body.classList.remove('no-scroll');
    }
  });
});


// accordion JS code
var acc = document.getElementsByClassName("cst-accordion");
var i;

for (i = 0; i < acc.length; i++) {
  acc[i].addEventListener("click", function() {
    this.classList.toggle("cst-active");
    var panel = this.nextElementSibling;
    if (panel.style.maxHeight) {
      panel.style.maxHeight = null;
    } else {
      panel.style.maxHeight = panel.scrollHeight + "px";
    } 
  });
}


// slick slider for feature collections
document.addEventListener('DOMContentLoaded', function() {
  var sliders = document.querySelectorAll('.collection-slider');
  
  sliders.forEach(function(slider) {
    var numSlides = 2;
    var slideToscroll = 2;
    
    if(window.innerWidth >= 750) {
      numSlides = 3;
      slideToscroll = 3;
    }
    if(window.innerWidth >= 1023) {
      numSlides = slider.getAttribute('data-slides');
      slideToscroll = 3;
    }

    // Initialize the Slick slider with jQuery (since Slick relies on jQuery)
    if (window.jQuery) {
      $(slider).slick({ 
        slidesToShow: numSlides,
        adaptiveHeight: true,
        infinite: true,
        draggable: true,
        slidesToScroll: slideToscroll,
        accessibility: false,
      });
    }
  });
});

document.addEventListener('DOMContentLoaded', function () {
  const sliderContainers = document.querySelectorAll('.collection-slider');
  if (!sliderContainers.length) return;

  function updateLinksTabIndex(gridItem) {
    const isHidden = gridItem.getAttribute('aria-hidden') === 'true';
    const links = gridItem.querySelectorAll('a');

    links.forEach(function (link) {
      if (isHidden) {
        link.setAttribute('tabindex', '-1');
      } else {
        link.removeAttribute('tabindex');
      }
    });
  }

  function initSlider(sliderContainer) {
    // Initial pass for any grid items already present (real + pre-rendered clones)
    sliderContainer.querySelectorAll('.grid__item').forEach(updateLinksTabIndex);

    // Single observer handles both attribute changes AND newly added nodes (clones)
    const observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        // Case 1: aria-hidden changed on an existing grid item
        if (mutation.type === 'attributes' && mutation.attributeName === 'aria-hidden') {
          const target = mutation.target;
          if (target.classList && target.classList.contains('grid__item')) {
            updateLinksTabIndex(target);
          }
        }

        // Case 2: new nodes added (e.g. Slick clones for infinite/centered mode)
        if (mutation.type === 'childList') {
          mutation.addedNodes.forEach(function (node) {
            if (node.nodeType !== 1) return;

            if (node.matches && node.matches('.grid__item')) {
              updateLinksTabIndex(node);
            }

            if (node.querySelectorAll) {
              node.querySelectorAll('.grid__item').forEach(updateLinksTabIndex);
            }
          });
        }
      });
    });

    observer.observe(sliderContainer, {
      attributes: true,
      attributeFilter: ['aria-hidden'],
      childList: true,
      subtree: true
    });
  }

  // Initialize independently for every collection-slider on the page
  sliderContainers.forEach(initSlider);
});